import { jsx, jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Intent, Button, Classes } from "@blueprintjs/core";
import { noop } from "lodash-es";
import classNames from "classnames";
function DialogFooter({
  hideModal,
  loading,
  submitting,
  onBackClick,
  style,
  onClick = noop,
  secondaryAction,
  secondaryDisabled,
  secondaryNotMinimal,
  intent = Intent.PRIMARY,
  secondaryIntent,
  backText = "Back",
  secondaryText = "Cancel",
  additionalButtons,
  className,
  secondaryClassName = "",
  text = "Submit",
  disabled,
  containerClassname,
  noCancel
}) {
  const divRef = useRef();
  return /* @__PURE__ */ jsx(
    "div",
    {
      style,
      ref: divRef,
      className: classNames(Classes.DIALOG_FOOTER, containerClassname),
      children: /* @__PURE__ */ jsxs("div", { className: Classes.DIALOG_FOOTER_ACTIONS, children: [
        onBackClick && /* @__PURE__ */ jsx(
          Button,
          {
            className: Classes.MINIMAL + " " + secondaryClassName,
            text: backText,
            onClick: onBackClick
          }
        ),
        !noCancel && /* @__PURE__ */ jsx(
          Button,
          {
            intent: secondaryIntent,
            disabled: secondaryDisabled,
            className: (!secondaryNotMinimal ? Classes.MINIMAL : "") + " " + secondaryClassName,
            text: secondaryText,
            onClick: secondaryAction || hideModal || function() {
              try {
                divRef.current.closest(".bp3-dialog").querySelector(".bp3-dialog-close-button").click();
              } catch (error) {
                console.error(`error closing dialog:`, error);
              }
            }
          }
        ),
        additionalButtons,
        /* @__PURE__ */ jsx(
          Button,
          {
            text,
            intent,
            type: "submit",
            className,
            onClick,
            disabled,
            loading: loading || submitting
          }
        )
      ] })
    }
  );
}
export default DialogFooter;
